/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Te_Summary_Easy_MaintenanceInputs */

const en_ui_te_summary_easy_maintenance = /** @type {(inputs: Ui_Te_Summary_Easy_MaintenanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Easy maintenance session — light aerobic stimulus.`)
};

const de_ui_te_summary_easy_maintenance = /** @type {(inputs: Ui_Te_Summary_Easy_MaintenanceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lockere Erhaltungseinheit — leichter aerober Reiz.`)
};

/**
* | output |
* | --- |
* | "Easy maintenance session — light aerobic stimulus." |
*
* @param {Ui_Te_Summary_Easy_MaintenanceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_te_summary_easy_maintenance = /** @type {((inputs?: Ui_Te_Summary_Easy_MaintenanceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Te_Summary_Easy_MaintenanceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_te_summary_easy_maintenance(inputs)
	return de_ui_te_summary_easy_maintenance(inputs)
});